import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 17331 16968"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970278507216">
        <path
          d="M10465 9937c-264-99-561 99-561 396v4555H6602v-4555c0-297-297-495-561-396l-3400 1320 5612-9739 5612 9739-3400-1320zM8583 495c-165-264-561-264-726 0L1320 11852c-99 164-66 330 33 462 100 131 298 165 462 131l3929-1518v4358c0 231 198 429 429 429h4127c231 0 429-198 429-429v-4358l3928 1518c166 67 364 34 463-131 99-132 132-330 33-462L8583 495zM825 3136c0-561 462-1023 1024-1023 561 0 1023 462 1023 1023s-462 1024-1023 1024c-562 0-1024-463-1024-1024zm2872 0c0-1023-825-1849-1848-1849C825 1287 0 2113 0 3136c0 1024 825 1849 1849 1849 1023 0 1848-825 1848-1849zM15252 5810c-463 0-826-363-826-825 0-463 363-825 826-825 462 0 825 362 825 825 0 462-363 825-825 825zm0-2476c-925 0-1651 727-1651 1651s726 1651 1651 1651c924 0 1650-727 1650-1651s-726-1651-1650-1651zM13601 16110c-231 0-429-198-429-429s198-429 429-429 429 198 429 429c0 264-198 429-429 429zm0-1651c-693 0-1254 562-1254 1255s561 1254 1254 1254 1255-561 1255-1254-562-1255-1255-1255zM15416 726c238 0 430 192 430 429s-192 430-430 430c-236 0-428-193-428-430s192-429 428-429zM4952 0c237 0 429 192 429 429s-192 429-429 429-430-192-430-429S4715 0 4952 0zM1221 7427c237 0 430 193 430 430s-193 429-430 429-429-192-429-429 192-430 429-430zM2476 15285c237 0 429 192 429 429s-192 429-429 429-430-192-430-429 193-429 430-429zM16902 13634c237 0 429 192 429 429s-192 429-429 429-429-192-429-429 192-429 429-429z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
